<template>
  <base-layout>
    <v-row
      v-if="!isBillNotFound"
      class="full-height"
      align="center"
      justify="center">
      <v-col
        cols="12"
        align-self="center"
        class="text-center">
        <p class="font-weight-bold">
          ออเดอร์ถูกสร้างสำเร็จแล้ว กรุณารอทางสาขาตรวจสอบ และจัดเตรียมสินค้า
        </p>
        <p class="font-weight-bold mb-10">
          เลขที่ออเดอร์ : {{ order.id }}
        </p>
        <p class="mb-10">
          <span class="font-weight-bold">ลิงก์บิลสำหรับส่งให้ลูกค้า</span> :
          <a
            id="linkbill"
            target="_blank"
            :href="fullLinkBill">
            {{ fullLinkBill }}
          </a>

          <v-icon
            style="cursor: pointer;"
            @click="copyLinkbill()">
            mdi-content-copy
          </v-icon>
        </p>
        <v-btn @click="$router.push({ name: 'Product' })">
          Back
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-else
      class="full-height"
      align="center"
      justify="center">
      <v-col
        cols="12"
        align-self="center"
        class="text-center">
        <p class="font-weight-bold">
          ไม่พบออเดอร์นี้
        </p>
        <v-btn @click="$router.push({ name: 'Home' })">
          Home
        </v-btn>
      </v-col>
    </v-row>
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import OrderProvider from '@/resources/order.service'

const orderService = new OrderProvider()

export default {
  data () {
    return {
      linkBill: process.env.VUE_APP_LINK_BILL,
      order: {},
      isBillNotFound: false
    }
  },
  computed: {
    billId () {
      return this.$route.params.id ? this.$route.params.id : ''
    },
    fullLinkBill () {
      return this.order.url ? `${this.linkBill}/${this.order.url}` : ''
    }
  },
  async mounted () {
    try {
      this.setLoading({
        active: true,
        clickAble: false,
        message: 'Fetching order.'
      })
      const { data: { bill } } = await orderService.getBillById(this.billId)
      this.order = bill
    } catch (error) {
      this.isBillNotFound = true
    } finally {
      this.setLoading({
        active: false,
        clickAble: false,
        message: 'Fetching order.'
      })
    }
  },
  methods: {
    ...mapActions({
      setLoading: 'Style/setLoading',
      setSnackbar: 'Style/setSnackbar'
    }),
    copyLinkbill () {
      this.setSnackbar({
        value: true,
        message: 'Link Copied!',
        type: 'success'
      })
      const copyText = document.getElementById('linkbill')
      const textArea = document.createElement('textarea')
      textArea.value = copyText.textContent
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('Copy')
      textArea.remove()
    }
  }
}
</script>
